import { useEffect, useRef } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useFetchFiles, useGetPatients } from "utils/hooks";
import { FileResource } from "types";

interface useGetPrivateFilesProps {
  patientSlug?: string;
}

const useGetPrivateFiles = ({ patientSlug }: useGetPrivateFilesProps) => {
  const dataRef = useRef(false);
  const { fetchPrivateFiles } = useFetchFiles();

  const files = useSelector(
    (state: RootStateOrAny) => state.files && state.files
  );

  useEffect(() => {
    if (dataRef.current) return;
    fetchPrivateFiles();
    dataRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { patient } = useGetPatients({ slug: patientSlug });

  const filterFilesByPatientId = (files: FileResource[], patientId: string) => {
    return files.filter((file) => file.privatePatientId === patientId);
  };

  return {
    privateFiles: patientSlug
      ? filterFilesByPatientId(files?.privateFiles, patient.uuid)
      : files?.privateFiles,
  };
};

export default useGetPrivateFiles;
